import { VALID_PATH_SEGMENTS, PDP_MVT_PATH_SEGMENTS } from "./constants";

export const validPath = (pathsToCheck = VALID_PATH_SEGMENTS) =>
  typeof window !== "undefined" &&
  !!window.location.pathname
    .split("/")
    .find(pathSegment => pathsToCheck.find(path => !pathSegment.indexOf(path)));

export const bagCheckoutMVTPath = () => validPath(PDP_MVT_PATH_SEGMENTS);
